import React from "react";
import { Box, Typography } from "@mui/material";
import { Apple } from "@mui/icons-material";

export const IOS_APP_STORE_URL = "https://apps.apple.com/us/app/my-waypoint/id6807865684";

// A compact "Get the app" link — used wherever the full official App Store
// badge artwork would be overkill (auth screens, a portal sidebar footer)
// but a real Apple mark plus copy establishes it's an actual App Store link.
//
// Two modes: pass `onClick` to make this open the announcement dialog
// instead of navigating directly (so a customer who dismissed the
// automatic popup can still get back to it) — omit it to fall back to a
// plain direct link to the App Store.
export default function AppStoreLink({ sx, variant = "light", onClick }) {
  const isLight = variant === "light";
  const interactiveProps = onClick
    ? {
        component: "button",
        type: "button",
        onClick,
      }
    : {
        component: "a",
        href: IOS_APP_STORE_URL,
        target: "_blank",
        rel: "noopener noreferrer",
      };

  return (
    <Box
      {...interactiveProps}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.5,
        py: 0.75,
        borderRadius: 1.5,
        textDecoration: "none",
        border: "1px solid",
        borderColor: isLight ? "rgba(255,255,255,0.18)" : "divider",
        color: isLight ? "rgba(255,255,255,0.85)" : "text.secondary",
        bgcolor: "transparent",
        cursor: "pointer",
        fontFamily: "inherit",
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: isLight ? "rgba(255,255,255,0.4)" : "text.secondary",
          color: isLight ? "#fff" : "text.primary",
        },
        ...sx,
      }}
    >
      <Apple sx={{ fontSize: 20 }} />
      <Box sx={{ lineHeight: 1.1, textAlign: "left" }}>
        <Typography sx={{ fontSize: 8.5, opacity: 0.85, display: "block" }}>Download on the</Typography>
        <Typography sx={{ fontSize: 13, fontWeight: 700, display: "block" }}>App Store</Typography>
      </Box>
    </Box>
  );
}
